import { render, staticRenderFns } from "./PdpTilesForFeel.vue?vue&type=template&id=6a129468&scoped=true&"
import script from "./PdpTilesForFeel.vue?vue&type=script&lang=js&"
export * from "./PdpTilesForFeel.vue?vue&type=script&lang=js&"
import style0 from "./PdpTilesForFeel.vue?vue&type=style&index=0&id=6a129468&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a129468",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppInfoModal: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppInfoModal.vue').default})
